import React from 'react'

import { BorderLoader } from '@/components/ui/loaders/border-loader'

import * as S from './button.styled'
import { ButtonProps } from './button.types'

export const Button = ({
  use = 'primary',
  size = 'medium',
  children,
  disabled = false,
  loading = false,
  onlyBox = false,
  onlyCircle = false,
  onClick,
  ...rest
}: ButtonProps) => {
  const overrideDisabled = loading
  const isDisabled = disabled || overrideDisabled

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => !isDisabled && onClick?.(e)

  return (
    <S.Button
      {...rest}
      $use={use}
      $size={size}
      $onlyBox={onlyBox}
      $onlyCircle={onlyCircle}
      $overrideDisabled={overrideDisabled}
      disabled={isDisabled}
      onClick={handleClick}
    >
      <S.ChildrenWrapper data-button-children-wrapper $size={size}>
        {children}
      </S.ChildrenWrapper>
      {loading && <BorderLoader data-button-loader align="absolute-center" size={size} />}
    </S.Button>
  )
}
